// extracted by mini-css-extract-plugin
export default {"container":"zqoA2pL5IOl69Zpbt1QF","busy":"VpvLllN6353lHilzjg4x","label":"nwnzwWQvTWIiW7YMzCFS","display":"CzTrQuoC5yvPbhfngrYO","spinner":"CbJRfP5sZznGNWILFGRa"};